import React, { useCallback } from 'react';
import {
  forEach as _forEach,
  clone as _clone,
  concat as _concat,
  isPlainObject as _isPlainObject,
  isArray as _isArray,
} from 'lodash';

// 1. Pure Core Functions (Single Source of Truth)
export const updateEntityShared = (
  { entity, changeEntity, defaultFieldTree },
  propertyName,
  value,
  fieldTree = [],
  callback = null,
  isLoud = true
) => {
  let computedFieldTree = fieldTree;
  if (defaultFieldTree !== undefined && defaultFieldTree !== null) {
    computedFieldTree = _concat(defaultFieldTree, computedFieldTree);
  }

  if (_isPlainObject(value)) {
    value = entity.createValue(propertyName, _clone(computedFieldTree), value);
  } else if (_isArray(value)) {
    value = value.map(valueEntry => entity.createValue(propertyName, _clone(computedFieldTree), valueEntry));
  }
  const newEntity = { ...entity.updateValue(propertyName, value, computedFieldTree) };

  changeEntity(newEntity, callback, isLoud);
};

export const updateEntityMultipleShared = (
  { entity, changeEntity, defaultFieldTree },
  propertyNames,
  values,
  fieldTrees = [],
  callback = null,
  isLoud = true
) => {
  let currentEntity = entity;

  _forEach(propertyNames, (propertyName, i) => {
    let value = values[i];
    let fieldTree = fieldTrees[i] !== undefined && fieldTrees[i] !== null ? fieldTrees[i] : [];
    if (defaultFieldTree !== undefined && defaultFieldTree !== null) {
      fieldTree = _concat(defaultFieldTree, fieldTree);
    }

    if (_isPlainObject(value)) {
      value = currentEntity.createValue(propertyName, _clone(fieldTree), value);
    } else if (_isArray(value)) {
      value = value.map(valueEntry => currentEntity.createValue(propertyName, _clone(fieldTree), valueEntry));
    }
    currentEntity = currentEntity.updateValue(propertyName, value, fieldTree);
  });

  changeEntity({ ...currentEntity }, callback, isLoud);
};


// 2. The New Custom Hook for Functional Components

export function useEntityPropsUpdater(entity, changeEntity, defaultFieldTree = null) {
  const updateEntityViaHook = useCallback(
    (propertyName, value, fieldTree = [], callback = null, isLoud = true) => {
      updateEntityShared({ entity, changeEntity, defaultFieldTree }, propertyName, value, fieldTree, callback, isLoud);
    },
    [entity, changeEntity, defaultFieldTree]
  );

  const updateEntityMultipleViaHook = useCallback(
    (propertyNames, values, fieldTrees = [], callback = null, isLoud = true) => {
      updateEntityMultipleShared({ entity, changeEntity, defaultFieldTree }, propertyNames, values, fieldTrees, callback, isLoud);
    },
    [entity, changeEntity, defaultFieldTree]
  );

  return { updateEntityViaHook, updateEntityMultipleViaHook };
}


// 3. The Old Class for Existing Components (Legacy)

export default class EntityPropsUpdater extends React.Component {
  updateEntity = (propertyName, value, fieldTree = [], callback = null, isLoud = true) => {
    if (this.defaultFieldTree !== undefined) {
      fieldTree = _concat(this.defaultFieldTree, fieldTree);
    }
    const { entity, changeEntity } = this.props;

    if (_isPlainObject(value)) {
      value = entity.createValue(propertyName, _clone(fieldTree), value);
    } else if (_isArray(value)) {
      value = value.map(valueEntry => entity.createValue(propertyName, _clone(fieldTree), valueEntry));
    }
    const newEntity = { ...entity.updateValue(propertyName, value, fieldTree) };

    changeEntity(newEntity, callback, isLoud);
  };

  updateEntityMultiple = (propertyNames, values, fieldTrees = [], callback = null, isLoud = true) => {
    const { entity, changeEntity } = this.props;

    let newEntity;
    _forEach(propertyNames, (propertyName, i) => {
      let value = values[i];
      let fieldTree = fieldTrees[i] !== undefined && fieldTrees[i] !== null ? fieldTrees[i] : [];
      if (this.defaultFieldTree !== undefined) {
        fieldTree = _concat(this.defaultFieldTree, fieldTree);
      }

      if (_isPlainObject(value)) {
        value = entity.createValue(propertyName, _clone(fieldTree), value);
      } else if (_isArray(value)) {
        value = value.map(valueEntry => entity.createValue(propertyName, _clone(fieldTree), valueEntry));
      }

      newEntity = { ...entity.updateValue(propertyName, value, fieldTree) };
    });

    changeEntity(newEntity, callback, isLoud);
  };
}
